import React from 'react';
import {Link} from 'react-router-dom';

import {Button} from 'reactstrap';
import ButtonEdit from './ButtonEdit';
import ButtonVideoGuide from './ButtonVideoGuide';
import ButtonDocGuide from './ButtonDocGuide';
import ButtonDevGuide from './ButtonDevGuide';
import ButtonDataTemplate from './ButtonDataTemplate';
import ButtonFileTemplate from './ButtonFileTemplate';
import classNames from 'classnames';
import MuiIcon from 'components/Icons/MuiIcon';

export {
  ButtonEdit,
  ButtonVideoGuide,
  ButtonDocGuide,
  ButtonDevGuide,
  ButtonDataTemplate,
  ButtonFileTemplate,
};

export class BaseButton extends React.Component {
  static defaultProps = {
    text: '',
    to: '',
    color: 'primary',
    size: '',
    icon: '',
  };

  render() {
    const {
      text,
      to,
      color,
      size,
      icon,
      children,
      iconProps,
      iconClassName,
      ...rest
    } = this.props;

    return (
      <Button
        to={to}
        tag={to ? Link : 'button'}
        color={color}
        size={size}
        {...rest}
      >
        {!!icon && (
          <MuiIcon
            name={icon}
            fixedWidth
            className={classNames('mr-1', iconClassName)}
            {...iconProps}
          />
        )}
        {!!text && <span>{text}</span>}
        {!!children && <span>{children}</span>}
      </Button>
    );
  }
}

export class ButtonLink extends React.Component {
  static defaultProps = {
    to: '',
  };

  render() {
    const {to, children, ...rest} = this.props;

    return (
      <Link to={to} {...rest}>
        {!!children && children}
      </Link>
    );
  }
}
